import { useState } from 'react';
import { useContent } from '../ContentContext';
import { PageHero, SectionHead } from '../components/Common';
import { submitEnquiry } from '../api';

const BLANK = { name: '', phone: '', email: '', subject: '', message: '', captcha: '' };

export default function ContactUs() {
  const { company = {}, aboutHome = {} } = useContent();
  const [form, setForm] = useState(BLANK);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      setMsg({ type: 'err', text: 'Please enter your name and phone number.' });
      return;
    }
    if (form.captcha.trim() !== '4') {
      setMsg({ type: 'err', text: 'Incorrect answer to the verification question.' });
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      await submitEnquiry({
        name: form.name,
        phone: form.phone,
        email: form.email,
        subject: form.subject,
        message: form.message,
        source: 'contact',
      });
      setForm(BLANK);
      setMsg({ type: 'ok', text: 'Thank you! Your enquiry has been sent — our team will contact you shortly.' });
    } catch (err) {
      setMsg({ type: 'err', text: err.message });
    } finally {
      setBusy(false);
    }
  };

  const cards = [
    { icon: 'fa-location-dot', title: 'Address', body: company.address },
    {
      icon: 'fa-phone',
      title: 'Phone',
      body: (company.phones || []).map((p) => (
        <span key={p} style={{ display: 'block' }}>
          <a href={`tel:+91${p}`}>+91 {p}</a>
        </span>
      )),
    },
    {
      icon: 'fa-envelope',
      title: 'Email',
      body: <a href={`mailto:${company.email}`}>{company.email}</a>,
    },
    {
      icon: 'fa-globe',
      title: 'Website',
      body: (company.sites || []).slice(-1).map((s) => (
        <a key={s} href={`https://${s}`} target="_blank" rel="noreferrer">{s}</a>
      )),
    },
  ];

  return (
    <>
      <PageHero title="Contact Us" image={aboutHome.image} />

      <section>
        <div className="container">
          <SectionHead
            title="Let's Discuss Your Requirement"
            text={`Contact ${company.name} for premium quality rice, export enquiries and bulk orders.`}
          />

          <div className="contact-grid">
            {cards.map((c) => (
              <div className="contact-card" key={c.title}>
                <i className={`fas ${c.icon}`} />
                <h4>{c.title}</h4>
                <p>{c.body}</p>
              </div>
            ))}
          </div>

          <form className="enquiry-form" onSubmit={submit}>
            <h3 style={{ color: 'var(--maroon)', marginBottom: 18, textAlign: 'center' }}>
              Send Enquiry
            </h3>
            <div className="form-row">
              <div className="field">
                <label>Name *</label>
                <input value={form.name} onChange={set('name')} placeholder="Your name" />
              </div>
              <div className="field">
                <label>Phone *</label>
                <input value={form.phone} onChange={set('phone')} placeholder="Your phone" />
              </div>
            </div>
            <div className="form-row">
              <div className="field">
                <label>Email</label>
                <input type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" />
              </div>
              <div className="field">
                <label>Subject</label>
                <input value={form.subject} onChange={set('subject')} placeholder="Bulk order / Export enquiry" />
              </div>
            </div>
            <div className="field">
              <label>Message</label>
              <textarea rows={4} value={form.message} onChange={set('message')} placeholder="Tell us your requirement" />
            </div>
            <div className="field">
              <label>2 + 2 = ?</label>
              <input value={form.captcha} onChange={set('captcha')} placeholder="Answer" />
            </div>
            <button className="consult-btn" style={{ width: '100%' }} type="submit" disabled={busy}>
              {busy ? 'Sending…' : 'Submit Enquiry'}
            </button>
            {msg ? <p className={`form-msg ${msg.type}`}>{msg.text}</p> : null}
          </form>
        </div>
      </section>
    </>
  );
}
